import * as likeCommentAPi from '../api/like-comment'
import { handleApiError } from './api-errors'

export const LIKE_COMMENT = "LIKE_COMMENT"
export const UNLIKE_COMMENT = "UNLIKE_COMMENT"

export const likeComment = (idea_id, comment_id) => (dispatch) => {
    likeCommentAPi.putObj(idea_id, comment_id).then(res => {
        dispatch({
            type: LIKE_COMMENT,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}

export const unlikeComment = (idea_id, comment_id) => (dispatch) => {
    likeCommentAPi.deleteObj(idea_id, comment_id).then(res => {
        dispatch({
            type: UNLIKE_COMMENT,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}
